import { post } from "@insite/client-framework/Services/ApiService";
import {
    AdyenPaymentDetailsModel,
    AdyenPaymentModel,
    PaymentAuthenticationModel
} from "@insite/client-framework/Services/PaymentService";

export * from "@insite/client-framework/Services/PaymentService";

const poolcorpPaymentAuthenticationUrl = "api/v1/poolcorp/paymentauthentication";

declare module "@insite/client-framework/Services/PaymentService" {
    interface PaymentAuthenticationModel {
        enableStoredPaymentMethods?: boolean,
        enableAddressValidationSystem?: boolean,
        enableRemoveStoredPaymentMethods?: boolean
    }
}

interface AdyenRemoveProfile {
    storedPaymentMethodId: string;
}

export function getAdyenSessionData(
    orderAmount: number | undefined,
    returnUrl: string | undefined,
    cartId: string | undefined,
    isCheckout: boolean | undefined,
) {
    const parameter = {
        operation: "initiate",
        orderAmount,
        returnUrl,
        cartId,
        isCheckout,
    };

    return post<any, PaymentAuthenticationModel>(`${poolcorpPaymentAuthenticationUrl}/adyencreatesession`, parameter);
}

export function getAdyenPaymentDetails(redirectResult: string) {
    const parameter = {
        details: {
            redirectResult,
        },
    };

    return post<any, AdyenPaymentDetailsModel>(`${poolcorpPaymentAuthenticationUrl}/adyenpaymentdetails`, parameter);
}

export function postAdyenPayment(
    webOrderNumber: string,
    orderAmount: number,
    currencyCode: string,
    returnUrl: string,
    data: any,
) {
    const parameter = {
        ...data,
        amount: {
            currency: currencyCode,
            value: orderAmount, // Poolcorp Custom Code - Removed the converted amount, need the original
        },
        reference: webOrderNumber,
        returnUrl,
        isCheckout: true // Poolcorp Custom Code
    };

    return post<any, AdyenPaymentModel>(`${poolcorpPaymentAuthenticationUrl}/adyenpayment`, parameter);
}

export function adyenRemoveStoredPaymentMethod(
    storedPaymentMethodId: string
) {
    const parameter = {
        storedPaymentMethodId
    };

    return post<AdyenRemoveProfile>(`${poolcorpPaymentAuthenticationUrl}/adyenremovestoredpaymentmethod`, parameter);
}